export const environment = {
  general: {
    production: false,
    product: 'retail',
    title: 'Kiosco El Molino',
    url: 'https://server.buhomanager.com:444/',
    useMultiClient: false,
    nameMultiClient: 'elmolino',
    logoUrl: 'https://buho-images.s3.sa-east-1.amazonaws.com/elmolino/logo.png',
    carouselImages: 0,
    phoneNumber: 543541529194,
    columnsItemMobile: 1,
    validateStock: false,
    mobileApp: true,
  },
  bucketConfig: {
    region: 'sa-east-1',
    accessKey: '',
    secretAccessKey: '',
    bucketName: 'buho-images',
    bucketFolderToSavePhotos: 'multiclient/upload/photos-articles/',
    bucketFolderToSaveFiles: 'multiclient/upload/files/',
  },
  htmlContent: {
    separator: ''
  },
  mercadoPago: {
    useMercadoPago: true,
    MercadoPago_Token_Test: '',
    MercadoPago_Token_Prod: '',
    MercadoPago_Back_Url: 'https://kioscoelmolino.com'
  },
  localPayment: false,
  shipping: {
    useShipping: true,
    correoArgentino: false
  }
};